module.exports = __webpack_public_path__ + "static/NotoSans-Bold.subset-4c852a80972c9b01a7bc13cee2f0ab5b.woff2";